import { Mail, Phone, MapPin } from "lucide-react";
import PageBanner from "../components/PageBanner";
import InquiryForm from "../components/InquiryForm";
import SEO from "../lib/SEO";
import { useSettings } from "../lib/SettingsContext";

export default function Contact() {
    const { settings } = useSettings();
    return (
        <main data-testid="contact-page">
            <SEO
                title="Contact — Cake Central"
                description="Get in touch with Cake Central to enquire about a custom cake in Sydney."
                path="/contact"
            />
            <PageBanner
                eyebrow="Say hello"
                title="Contact Us"
                image="https://images.unsplash.com/photo-1659401083689-240a4f511a76?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
            />

            <section className="bg-[#FFF7FB] py-16 md:py-24">
                <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid md:grid-cols-5 gap-12">
                        <aside className="md:col-span-2 space-y-8">
                            <div>
                                <p className="text-xs tracking-[0.3em] uppercase text-ink-soft mb-3">Studio</p>
                                <p className="inline-flex items-center gap-2 text-ink">
                                    <MapPin size={16} className="text-blush" /> {settings.address}
                                </p>
                            </div>
                            <div>
                                <p className="text-xs tracking-[0.3em] uppercase text-ink-soft mb-3">Email</p>
                                <a
                                    href={`mailto:${settings.email}`}
                                    className="inline-flex items-center gap-2 text-ink hover:text-blush transition-colors"
                                    data-testid="contact-email"
                                >
                                    <Mail size={16} className="text-blush" /> {settings.email}
                                </a>
                            </div>
                            <div>
                                <p className="text-xs tracking-[0.3em] uppercase text-ink-soft mb-3">Phone</p>
                                <a
                                    href={`tel:${settings.phone?.replace(/\s/g, "")}`}
                                    className="inline-flex items-center gap-2 text-ink hover:text-blush transition-colors"
                                    data-testid="contact-phone"
                                >
                                    <Phone size={16} className="text-blush" /> {settings.phone}
                                </a>
                            </div>
                            <div className="pt-6 border-t border-[#EAE3DE]">
                                <p className="text-sm text-ink-soft leading-relaxed">
                                    For weddings, special events and larger orders, please share as much detail as
                                    you can — flavours, servings, date, and any inspiration — and we'll come back
                                    within 1–2 business days.
                                </p>
                            </div>
                        </aside>

                        <div className="md:col-span-3 bg-white border border-[#EAE3DE] p-6 md:p-10">
                            <h2 className="font-display text-2xl md:text-3xl mb-2">Send us an enquiry</h2>
                            <p className="text-sm text-ink-soft mb-8">We'll reply with a tailored quote.</p>
                            <InquiryForm />
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}
